"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressDate = exports.EndDate = exports.StartDate = void 0;
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const common_1 = require("../../../../../common");
const moment_1 = __importDefault(require("moment"));
const GlobalStateProvider_1 = require("../../../../../GlobalStateProvider");
// 시작일 컴포넌트
exports.StartDate = react_1.default.memo(({ startDate, startTime, setStartDate, setStartTime, updateStartNow, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { isMobile } = (0, GlobalStateProvider_1.useGlobalState)();
    const now = (0, moment_1.default)();
    const [startNow, setStartNow] = react_1.default.useState(false); // 바로 시작하기
    const handlerClick = () => {
        const changeDate = !startNow;
        updateStartNow(changeDate);
        setStartNow(changeDate);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "field-global-001", style: { alignItems: isMobile && 'flex-start' } },
            react_1.default.createElement("div", { className: "task-label" }, t('assignment.startDate')),
            react_1.default.createElement("div", { className: `fext-field ${isMobile ? 'mobile-date-wrap' : ''}` },
                react_1.default.createElement(common_1.InputElement, { type: "date", value: startDate, onChange: setStartDate, min: now.format('YYYY-MM-DD') }),
                react_1.default.createElement(common_1.InputElement, { type: "time", value: startTime, onChange: setStartTime }))),
        react_1.default.createElement(common_1.CheckBoxElement, { className: "assignment-checkbox-txt start-now", style: { gap: 6 }, id: "1", title: "assignment.startNow", checked: startNow, handlerCheck: handlerClick })));
});
exports.EndDate = react_1.default.memo(({ endDate, endTime, setEndDate, setEndTime, labelKey = 'assignment.endDate', }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { isMobile, isTablet } = (0, GlobalStateProvider_1.useGlobalState)();
    const now = (0, moment_1.default)();
    return (react_1.default.createElement("div", { className: "field-global-001", style: { width: '100%', alignItems: 'flex-start' } },
        react_1.default.createElement("div", { className: "task-label" }, t(labelKey)),
        react_1.default.createElement("div", { className: `fext-field ${isMobile ? 'mobile-date-wrap' : ''}` },
            react_1.default.createElement(common_1.InputElement, { type: "date", value: endDate, onChange: setEndDate, min: now.format('YYYY-MM-DD') }),
            react_1.default.createElement(common_1.InputElement, { type: "time", value: endTime, onChange: setEndTime }))));
});
// 시작일 컴포넌트
exports.ProgressDate = react_1.default.memo(({ startDate, startTime, setStartDate, setStartTime, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const now = (0, moment_1.default)();
    const updateDate = (date) => {
        setStartDate(date);
    };
    return (react_1.default.createElement("div", { className: "field-global-001" },
        react_1.default.createElement("div", { className: "task-label" }, t('assignment.startDate')),
        react_1.default.createElement("div", { className: "fext-field" },
            react_1.default.createElement(common_1.InputElement, { type: "date", value: startDate, onChange: updateDate, min: now.format('YYYY-MM-DD') }))));
});
